import React from 'react';
import NoiseTracker from './components/NoiseTracker';
import './App.css';

function App() {
  return (
    <div className='App'>
      <NoiseTracker />
    </div>
  );
}

export default App;
